import { h, Component } from 'preact';
import PropTypes from 'prop-types';

import ScheduleServiceFixedTopForm from './ScheduleServiceFixedTopForm';

export default class ScheduleServiceFixedTopFormApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmittingForm: false,
      errorSendingForm: false,
      showOverlay: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
  }

  handleCloseOverlay() {
    this.setState({ showOverlay: false });

    const { link } = this.props;
    const { errorSendingForm } = this.state;

    if (link && !errorSendingForm) {
      window.open(link, '_self');
    }
  }

  handleSubmit(e, params) {
    this.setState({ isSubmittingForm: true });

    return serviceConversion
      .convert(params)
      .then(() => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: false
        });
      })
      .catch(error => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: true
        });
        console.error(error);
      })
      .then(() => {
        this.setState({
          showOverlay: true
        });
      });
  }

  render() {
    const { formId, services, product, channel, category } = this.props;

    return (
      <ScheduleServiceFixedTopForm
        formId={formId}
        handleSubmit={this.handleSubmit}
        isSubmittingForm={this.state.isSubmittingForm}
        errorSendingForm={this.state.errorSendingForm}
        handleCloseOverlay={this.handleCloseOverlay}
        showOverlay={this.state.showOverlay}
        services={services}
        product={product}
        channel={channel}
        category={category}
        brand={this.props.brand}
        units={this.props.units}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        titleForm={this.props.titleForm}
        subtitleForm={this.props.subtitleForm}
        versions={this.props.versions}
      />
    );
  }
}

ScheduleServiceFixedTopFormApp.defaultProps = {
  services: [],
  brand: '-',
  units: [],
  showUnits: true,
  showCpf: false,
  versions: [],
};

ScheduleServiceFixedTopFormApp.propTypes = {
  formId: PropTypes.string,
  services: PropTypes.array,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  showUnits: PropTypes.bool,
  showCpf: PropTypes.bool,
  titleForm: PropTypes.string,
  subtitleForm: PropTypes.string,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
};
